import type { MyTeams } from './forgejo';

export const NEW_TEAM_HREF = '/create/templates/default/nieuw-team';
export const NEW_ORGANISATION_HREF = '/create/templates/default/nieuwe-organisatie';

/**
 * The portal only sees organisations its bot is in. Someone who made one on code.overheid.nl
 * themselves needs to know why it is missing and what brings it in.
 */
export function HiddenOrganisationHint({ myTeams }: { myTeams: MyTeams }) {
  const { hidden, bot } = myTeams;
  return (
    <>
      <nldd-text size="sm" color="secondary">
        Zelf een organisatie gemaakt op code.overheid.nl? Die verschijnt hier zodra je {bot.login} toevoegt
        aan het team Owners van die organisatie.
      </nldd-text>
      <nldd-spacer size="8" />
      <nldd-container layout="wrap" gap="12">
        {hidden.length ? (
          hidden.map(organisation => (
            <nldd-link
              key={organisation.name}
              size="sm"
              href={organisation.addBotUrl}
              text={`${bot.login} toevoegen aan ${organisation.title}`}
            />
          ))
        ) : (
          <nldd-link size="sm" href={bot.organisationsUrl} text="Naar je organisaties op code.overheid.nl" />
        )}
      </nldd-container>
    </>
  );
}

/** For someone without a team: where one comes from, with the way to make one here. */
export function NoTeamDialog({ myTeams, codeUrl }: { myTeams?: MyTeams; codeUrl: string }) {
  const inOrganisation = myTeams?.organisations.some(organisation => organisation.isMember);
  return (
    <>
      <nldd-inline-dialog
        icon="account"
        text="Je zit nog niet in een team"
        supporting-text="Teams staan op code.overheid.nl. Maak er hier een, of vraag een collega je toe te voegen. Zit je in een team, dan kun je hier een dienst of API maken en zie je je repositories en pull requests."
      >
        <nldd-button
          slot="actions"
          appearance="primary"
          href={inOrganisation ? NEW_TEAM_HREF : NEW_ORGANISATION_HREF}
          text={inOrganisation ? 'Maak een team' : 'Maak een organisatie'}
        />
        <nldd-button slot="actions" appearance="secondary" href={codeUrl} text="Naar code.overheid.nl" />
      </nldd-inline-dialog>
      {myTeams ? (
        <>
          <nldd-spacer size="16" />
          <HiddenOrganisationHint myTeams={myTeams} />
        </>
      ) : null}
    </>
  );
}
